import {
  Search,
  Plus,
  MoreVertical,
  Pencil,
  Trash2,
  X,
  ListFilter,
  ChevronDown,
  ChevronUp,
  ChevronRight,
  RefreshCw,
  Download,
  Filter,
  Globe,
  Ban,
  ShieldOff,
  ArrowRight,
  Shield,
  Info,
  User,
  Sparkles,
  Check,
} from "lucide-react";

/** Common UI action icons for tables, toolbars, and modals. */
export const UI_ICONS = {
  search: Search,
  plus: Plus,
  more: MoreVertical,
  edit: Pencil,
  delete: Trash2,
  close: X,
  exception: ListFilter,
  chevronDown: ChevronDown,
  chevronUp: ChevronUp,
  chevronRight: ChevronRight,
  refresh: RefreshCw,
  download: Download,
  filter: Filter,
  manageDomain: Globe,
  disableDomain: Ban,
  deleteDomain: Trash2,
  disableWaf: ShieldOff,
  nextLine: ArrowRight,
  signatureWaf: Shield,
  globalWaf: Globe,
  info: Info,
  user: User,
  brand: Sparkles,
  check: Check,
};
